/* eslint-disable jsx-a11y/alt-text */
import React, { Component, Fragment } from "react";
import { shopContext } from "../contexts/aniplus";
import { withRouter } from "react-router-dom";

import ReactPlayer from "react-player";

//import axios from "axios";

class Tutorial extends Component {
  state = {
    playing: false,
    playIndex: 0,
    currentPlayIndex: 0,
    mute: true,
    playUrl: "https://jjmp4.ofscdn.com/TveeMovie/aniplus/newaniplus.mp4",
    imgShow: false,
    videoList: [
      { url: "https://jjmp4.ofscdn.com/TveeMovie/aniplus/newaniplus.mp4" },
    ],
  };
  componentDidMount = () => {
    this._getWindowSize();
    window.addEventListener("resize", this._getWindowSize);
    var body = document.querySelector("body");
    body.addEventListener("click", this.clickBodyEvent);
  };
  componentWillUnmount = () => {
    window.removeEventListener("resize", this._getWindowSize);
    var body = document.querySelector("body");
    body.removeEventListener("click", this.clickBodyEvent);
  };
  clickBodyEvent = (event) => {
    //let close = 'N'
    var target = event.target;
    var eventTarget = event.currentTarget.querySelector(".detail_view");

    //console.log(target, eventTarget)

    if (target === eventTarget) {
      this._onClose();
    } else {
    }
  };
  _liveTimeline = () => {
    const { setTimeline, setTutorialShow } = this.props;
    //해당 페이지 닫고.
    setTutorialShow(false);
    setTimeline(true);
  };
  _memberShip = () => {
    const { history, setTutorialShow } = this.props;
    //해당 페이지 닫고
    setTutorialShow(false);
    history.push("/ticket");
  };
  _onClose = () => {
    const { setTutorialShow } = this.props;
    setTutorialShow(false);
  };
  _onPlayVideo = () => {
    const { videoList, playIndex } = this.state;
    let currentPlayIndex;
    //console.log(videoList)

    if (videoList) {
      const playLenght = videoList.length;

      ////console.log(playIndex, playLenght)
      ////console.log('start')
      if (playLenght <= 0) {
        this.setState({
          playing: false,
          imgShow: true,
        });
      } else {
        if (playIndex >= playLenght) {
          //썸네일??? 고정!!!
          //currentPlayIndex = 0
          this.setState({
            playing: false,
            imgShow: true,
            //playUrl: videoList[currentPlayIndex].url,
            //playIndex: currentPlayIndex + 1,
            //currentPlayIndex: currentPlayIndex
          });
        } else {
          ////console.log(videoList[currentPlayIndex].url)
          currentPlayIndex = playIndex;

          this.setState({
            playing: true,
            playUrl: videoList[currentPlayIndex].url,
            playIndex: currentPlayIndex + 1,
            currentPlayIndex: currentPlayIndex,
          });
        }
      }
    }
  };
  _onReady = () => {
    this.setState({
      playing: true,
    });
  };
  _onEnded = () => {
    ////console.log('end')
    //애니플러스 로그 재생 후
    //this._onPlayVideo()
    this.setState({
      imgShow: true,
    });
  };
  _getWindowSize = () => {
    //console.log(window.innerWidth)
    const hSize = (window.innerWidth - 18) * (1080 / 1920);
    this.setState({
      wSize: window.innerWidth - 386,
      hSize: hSize,
    });
  };
  render() {
    const { playing, playUrl, imgShow, wSize, hSize, mute } = this.state;
    return (
      <Fragment>
        <div className={"detail_layer_pop"}>
          <div className="detail_view" style={{ overflowY: "scroll" }}>
            <div
              className="detail_layer_close"
              style={{ cursor: "pointer" }}
              onClick={this._onClose}
            >
              <img src="/img/detail_img/close_1.png" />
            </div>

            <div className="detail_view_layer">
              <div className="detil_top">
                <div className="logo_div">
                  <img src="/img/tutorial/logo.png" />
                </div>
              </div>

              <div className="baner">
                {imgShow ? (
                  <img
                    src="/img/tutorial/movie-still-img.png"
                    style={{ width: "100%" }}
                  />
                ) : (
                  <ReactPlayer
                    //url={'https://jjmp4.ofscdn.com' + liveData[0].opening}
                    className={"baner"}
                    playing={playing}
                    url={playUrl}
                    volume={0.5}
                    muted={mute}
                    onReady={this._onReady}
                    onEnded={this._onEnded}
                    width={wSize - 12}
                    height={hSize}
                  />
                )}
              </div>
              <div className="pop_padding_70">
                <div>
                  <img src="/img/tutorial/tutorial-page.png" useMap="#FPMap0" />
                  <map name="FPMap0">
                    <area
                      style={{ cursor: "pointer" }}
                      shape="rect"
                      coords="1114, 69, 1334, 122"
                      onClick={this._liveTimeline}
                    />
                    <area
                      style={{ cursor: "pointer" }}
                      coords="1089, 693, 1331, 756"
                      onClick={this._memberShip}
                    />
                    <area
                      style={{ cursor: "pointer" }}
                      shape="rect"
                      coords="1087, 1817, 1334, 1878"
                      onClick={this._memberShip}
                    />
                  </map>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default shopContext(withRouter(Tutorial));
